import clsx from 'clsx';

interface CardProps {
  children: React.ReactNode;
  className?: string;
}

export default function Card({ children, className }: CardProps) {
  return (
    <div className={clsx("bg-white rounded-xl shadow-sm p-4 sm:p-6 mb-4 border border-border transition-shadow hover:shadow-md", className)}>
      {children}
    </div>
  );
}
